export const STORAGE_KEYS_CONSTANTS = {
  /** llave o clave constante para el almacenamiento de idiomas */
  LANGUAGE: 'lang',

  /** llave o clave constante para el almacenamiento de sesión que será utilizada en peticiones o procesos referente a la autenticación*/
  AUTHENTICATION: 'auth',

  /** llave o clave constante para almacenamiento token */
  TOKEN: 'token',

  /** llave o clave constante para almacenamiento del refresh token */
  REFRESH_TOKEN: 'refresh_token',

  /** Clave que hace referencia a la primera curiosidad en el cache*/
  CURIOSITY_TOKEN: '_curiosity',

  /** clave que hace referencia al home la página principal cuando se guarda en cache*/
  HOME: 'home',

  /** llave para el almacenamiento del carrito */
  CHECKOUT: 'checkout',

  PURCHASE_DATA: 'purchaseData',

  /** llave para almacenar la decisión de consentimiento de cookies/analítica */
  COOKIE_CONSENT: 'cookie_consent',
} as const;
